import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSnackbar } from 'notistack';
import { useParams, useHistory } from 'react-router-dom';
import { isOnlyHexadecimal } from 'util/hexadecimal';
import { Paths } from 'router/routes';

export const VisualizacaoContext = createContext({
  codigoConsulta: null,
});

export const VisualizacaoContextProvider = ({ children }) => {
  const { enqueueSnackbar } = useSnackbar();
  const [codigoConsulta, setCodigo] = useState(null);
  const { codigoConsulta: param } = useParams();
  const history = useHistory();

  useEffect(() => {
    if (param && isOnlyHexadecimal(param)) {
      setCodigo(param);
      return;
    }
    enqueueSnackbar('Certificado não encontrado.', { variant: 'error' });
    history.push(Paths.VALIDACAO.split(':')[0]);
  }, [param, history, setCodigo, enqueueSnackbar]);

  return (
    <VisualizacaoContext.Provider value={{
      codigoConsulta,
    }}
    >
      {children}
    </VisualizacaoContext.Provider>
  );
};

VisualizacaoContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
